import { get, GetReturnType } from "src/api/fetch";
import { getSchemaFromUrl } from "src/router/routes";
import { Enum_Geometry_Types } from "src/types";

export const getFormsByType = (type: Enum_Geometry_Types): GetReturnType => {
    return get(`${VITE_API_URL}/${getSchemaFromUrl()}/forms/type/${type}`);
};
